import React, { useState, useEffect } from 'react';

import { Container as MuiContainer } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as createAttachmentModalActions from '../createAttachmentModal/actions';

import * as actions from './actions';
import ListItems from './components/ListItems';
import * as selectors from './selectors';

const Container = ({
    attachments,
    filterAttachments,
    handleClickBulkItems,
    handleSaveRow,
    handleClickUpdateAttachment,
    handleUpdateFilterData,
    isFetching,
    paginationData,
}) => {
    const [filterData, setFilterData] = useState({
        orderBy: 'created_at',
        page: 0,
        pageSize: 25,
        searchText: '',
        sortBy: 'desc',
        status: 'active',
    });

    useEffect(() => {
        filterAttachments(filterData);
    }, []);

    return (
        <MuiContainer maxWidth="false">
            <ListItems
                filterData={filterData}
                filterItems={filterAttachments}
                handleClickBulkItems={handleClickBulkItems}
                handleSaveRow={handleSaveRow}
                handleClickUpdateAttachment={handleClickUpdateAttachment}
                handleUpdateFilterData={handleUpdateFilterData}
                isFetching={isFetching}
                items={attachments}
                paginationData={paginationData}
                setFilterData={setFilterData}
            />
        </MuiContainer>
    );
};

Container.propTypes = {
    attachments: PropTypes.array,
    filterAttachments: PropTypes.func,
    handleClickBulkItems: PropTypes.func,
    handleSaveRow: PropTypes.func,
    handleClickUpdateAttachment: PropTypes.func,
    handleUpdateFilterData: PropTypes.func,
    isFetching: PropTypes.bool,
    paginationData: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
    attachments: selectors.getAttachmentsData,
    isFetching: selectors.getIsFetchingAttachments,
    isFetchingBulk: selectors.getIsFetchingBulk,
    isSaving: selectors.getIsSaving,
    paginationData: selectors.getAttachmentsPagination,
});

const mapDispatchToProps = (dispatch) => ({
    filterAttachments: (filterData) =>
        dispatch(actions.filterAttachments(filterData)),
    handleClickBulkItems: (ids, value, filterData, callback) =>
        dispatch(actions.prepareBulkItems(ids, value, filterData, callback)),
    handleSaveRow: (filterData, values) =>
        dispatch(actions.updateAttachment(filterData, values)),
    handleUpdateFilterData: (values) => dispatch(actions.setFilterData(values)),
    handleClickUpdateAttachment: (values) =>
        dispatch(createAttachmentModalActions.prepareUpdate(values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
